export function gotoAST(astId) {
  //@ts-ignore
  document.querySelectorAll('[ast_id]').forEach(x=>x.style.border="")
  var elm=document.querySelector('[ast_id="' + astId + '"]')
  if(!elm){
    console.log('cannot find element with ast:' + astId)
    return 
  }
  // elm.scrollIntoView({block:'center',inline:'nearest'})
  scrollIntoView(elm)

  //@ts-ignore
  elm.style.border='3px dashed white'
}

function getScrollParent(node) {
  if (node == null) {
    return null;
  }

  if (node.scrollHeight > node.clientHeight) {
    return node;
  } else {
    return getScrollParent(node.parentNode);
  }
}

/**
 * @param scState {scState}
 */
export function gotoResource(scState,gotoTab,gotoAstId){
  var tab=scState.json.tabsObject[gotoTab]
  if(!tab) {
    console.log(gotoTab , 'it is not a tab')
    return
  }
  scState.set_selectedResourseType(gotoTab)
  scState.set_selectedResource(tab.elements.find(x=>x.astId==gotoAstId))
}

export function scrollIntoView(elm) {
  var prn=getScrollParent(elm)
  prn.scrollTop=elm.offsetTop -prn.clientHeight/2
}

export function goto(scState,file,line) {
  scState.set_selectedFile(file)
  if(line) {
    setTimeout(()=>{
      var elm=document.querySelector(`[data-line="${line}"]`)
      //@ts-ignore
      elm.style.border='1px solid yellow'
      setTimeout(()=>{
        //@ts-ignore
        elm.style.border=''
      },3000)
      scrollIntoView(elm)
    })
  }
}